import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { findIndex, get } from "lodash";
import clsx from "clsx";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth/withWidth";
import Menu from "@material-ui/core/Menu/Menu";
import Button from "@material-ui/core/Button/Button";
import Grid from "@material-ui/core/Grid/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography/Typography";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Popper from "@material-ui/core/Popper";
import Paper from "@material-ui/core/Paper";
import LoadingOverlay from "../../../../../Framework/Components/LoadingOverlay";
import { CloseMenuIcon } from "../../../../../Icons";
import Option from "../Option";
import MobileMenuStep from "../../../../Shared/Components/MobileMenuStep";

const mobileAndTabletCheck = () => {
  const { userAgent } = navigator;

  const userAgentPart = userAgent.substr(0, 4);
  if (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
      "MacIntel",
    ].includes(navigator.platform) ||
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  ) {
    return true;
  }
  return (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
      userAgent
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      userAgentPart
    )
  );
};

const styles = (theme) => ({
  optionsMenu: {
    "& .MuiPaper-root": {
      width: 280,
      maxWidth: 280,
      borderRadius: 0,
      [theme.breakpoints.up("sm")]: {
        maxHeight: "60vh",
      },
    },
    "& .MuiList-root": {
      padding: `${theme.spacing(4)}px ${theme.spacing(6)}px`,
      paddingTop: 40,
      display: "flex",
      flexDirection: "column",
    },
  },
  contentStyle: {
    minHeight: 50,
  },
  closeButton: {
    borderRadius: 100,
    position: "absolute",
    right: theme.spacing(2),
    top: theme.spacing(2),
    minWidth: 14,
    padding: 4,
    marginTop: -4,
    marginRight: -4,
    "&:hover": {
      boxShadow: "none",
      background: "#F2F2F2",
    },
    "&:active, &:focus": {
      boxShadow: "none",
      background: "#C9C9C9",
    },
  },
  colorGrid: {
    width: 235,
    marginLeft: -7.5,
    marginRight: -7.5,
    [theme.breakpoints.up("sm")]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    "& .MuiGrid-item": {
      display: "flex",
      justifyContent: "center",
      minWidth: 32,
      margin: "0px 7.5px",
    },
  },
  textField: {
    "& .MuiInputBase-input": {
      padding: theme.spacing(1),
    },
  },
  radioFormControl: {
    marginTop: 10,
    "&.MuiFormControlLabel-root": {
      marginLeft: -15,
    },
    "& .MuiButtonBase-root": {
      "&:hover, &:focus, &:active": {
        background: "transparent",
      },
      padding: "6.5px 9px",
      paddingTop: 0,
      color: theme.layout.radio.color,
      marginTop: -3,
      "& .MuiIconButton-label": {
        borderRadius: 100,
        border: "3px solid transparent",
        "&:hover": {
          background: "#F2F2F2",
          border: "3px solid #F2F2F2",
        },
        "&:active,&:focus": {
          background: "#C9C9C9",
          border: "3px solid #C9C9C9",
        },
      },
    },
    "& .MuiTypography-root": {
      fontSize: 14,
      [theme.breakpoints.up("sm")]: {
        fontSize: 14,
      },
      [theme.breakpoints.up("md")]: {
        fontSize: mobileAndTabletCheck() ? 14 : 16,
      },
      [theme.breakpoints.up("xl")]: {
        fontSize: 16,
      },
    },
  },
  bobbel: {
    width: 9,
    height: 9,
    borderRadius: 100,
    marginRight: 8,
  },
  bobbelContainer: {
    display: "inline-flex",
    alignItems: "baseline",
  },
  detailList: {
    padding: 0,
    margin: theme.spacing(3),
  },
  typography: {
    margin: "-7px 0px",
    [theme.breakpoints.up("sm")]: {
      margin: "inherit",
    },
  },
  heading: {
    marginBottom: 5,
  },
});

const OptionsList = ({
  addCheckedOptionclassification,
  children,
  isLoading,
  onClose,
  onSelect,
  onToggle,
  optionclassification,
  options,
  show,
  viewDetails,
  viewStockInformation,
  LoadingComponent,
  OptionComponent,
  optionRef,
  classes,
  width,
  doDisplayMobile,
  currentModalContentOption,
  modalContentOptions,
  setModalContentOption,
  setDisplayCreatorMobilePicker,
}) => {
  const [customValue, setCustomValue] = useState("");
  const [selectedRadio, setSelecteRadio] = useState(null);

  useRef(() => {
    if (optionGroupChildren.length === 0) {
      optionIndex = findIndex(get(optionclassification, "selectedoptions"), {
        identifier: option.identifier,
      });
    } else {
      for (const item of optionGroupChildren) {
        optionIndex = findIndex(get(optionclassification, "selectedoptions"), {
          identifier: item.identifier,
        });
        if (optionIndex > -1) {
          // we need the first selected option
          break;
        }
      }
    }
  }, []);
  const closeMenu = () => {
    // console.log(onOptionClassificationSelect(dispatchAction, optionClassification, selectOptionClassification)
    if (currentModalContentOption === modalContentOptions.RENDER_ITEMMENU) {
      setModalContentOption(modalContentOptions.RENDER_OVERVIEW);
    }
    onToggle();
    onClose();
  };

  const createOptions = () => {
    const onOptionClicked = () => {
      addCheckedOptionclassification(optionclassification);
      closeMenu();
    };
    return options.map((option) => {
      let optionIndex = -1;

      const optionGroupChildren = get(option, "option_group.children", []);

      if (optionGroupChildren.length === 0) {
        optionIndex = findIndex(get(optionclassification, "selectedoptions"), {
          identifier: option.identifier,
        });
      } else {
        for (const item of optionGroupChildren) {
          optionIndex = findIndex(
            get(optionclassification, "selectedoptions"),
            {
              identifier: item.identifier,
            }
          );
          if (optionIndex > -1) {
            // we need the first selected option
            break;
          }
        }
      }

      const selected =
        optionIndex <= -1
          ? false
          : !(option.amount_is_selectable && option.amount < 1);

      return (
        <Grid key={`optionlistitem_${option.identifier}`} item xs={1}>
          <OptionComponent
            option={option}
            optionclassification={optionclassification}
            onSelect={onSelect}
            selected={selected}
            viewDetails={viewDetails}
            viewStockInformation={viewStockInformation}
            onClick={onOptionClicked}
            onToggle={onToggle}
          />
        </Grid>
      );
    });
  };

  const onOptionSelect = (option) => {
    const optionFound = options.find(
      (o) => o.identifier === option.target.value
    );
    if (!optionFound) return;
    onSelect({
      ...optionFound,
      amount: 1,
    });
    closeMenu();
  };

  const getBackground = (_option) => {
    const idx = _option.attributes.findIndex(
      (attribute) => attribute.identifier === "colorValue"
    );
    if (idx < 0) return {};
    if (_option.attributes[idx].values.length < 1) return {};
    return { backgroundColor: _option.attributes[idx].values[0].value };
  };

  const renderOptions = () => {
    // image grid is default case
    let optionListItems = [];
    let className = null;
    if (optionclassification.identifier?.includes("usb")) {
      className = classes.checkboxGrid;
      optionListItems = [];
      const sortedOptions = options.sort(({ netPrice: a }, { netPrice: b }) =>
        a === b ? 0 : a < b ? -1 : 1
      );
      return (
        <>
          <Typography variant="body1">
            <b>{t("optionsList.usbCapacityHeading")}</b>
          </Typography>
          <RadioGroup
            aria-label="options"
            name="options"
            onClick={onOptionSelect}
          >
            {sortedOptions.map((option) => (
              <FormControlLabel
                checked={
                  !!(optionclassification.selectedoptions || []).some(
                    (selected) => selected.identifier === option.identifier
                  )
                }
                className={classes.radioFormControl}
                key={option.identifier}
                value={option.identifier}
                label={
                  <>
                    <span>{option.title}</span>
                    <br />
                    <i>
                      {t("optionsList.optionSurcharge")}
                      :&nbsp;
                      {option.priceFormatted}
                    </i>
                  </>
                }
                control={<Radio disableRipple />}
              />
            ))}
          </RadioGroup>
        </>
      );
    }
    if (optionclassification.identifier === "mine") {
      className = classes.colorCheckboxGrid;
      optionListItems = [];
      return (
        <>
          <Typography variant="body1">
            <b>{t("optionsList.mineHeading")}</b>
          </Typography>
          <RadioGroup
            aria-label="options"
            name="options"
            onClick={onOptionSelect}
          >
            {options.map((option) => (
              <FormControlLabel
                checked={
                  !!(optionclassification.selectedoptions || []).some(
                    (selected) => selected.identifier === option.identifier
                  )
                }
                className={classes.radioFormControl}
                key={option.identifier}
                value={option.identifier}
                label={
                  <>
                    <span className={classes.bobbelContainer}>
                      <div
                        className={classes.bobbel}
                        style={getBackground(option)}
                      />
                      {option.title}
                    </span>

                    <br />
                    <i>
                      {t("optionsList.optionSurcharge")}
                      :&nbsp;
                      {option.priceFormatted}
                    </i>
                  </>
                }
                control={<Radio disableRipple />}
              />
            ))}
          </RadioGroup>
        </>
      );
    }
    if (!optionclassification.identifier) return <></>;

    className = classes.colorGrid;
    optionListItems = createOptions();

    return (
      <div>
        <Typography variant="body1">
          <b>{t("optionsList.colorHeading")}</b>
        </Typography>
        {children ||
          (optionListItems.length > 0 ? (
            <Grid className={className} container>
              {optionListItems}
            </Grid>
          ) : null)}
        <LoadingComponent show={isLoading} />
        <br />
        <Typography
          className={clsx(classes.typography, classes.heading)}
          variant="body1"
        >
          <b>{t("optionsList.extraColorHeading")}</b>
        </Typography>
        <Typography className={classes.typography} variant="body1">
          {t("optionsList.extraColorInfo")}
          {/* <br />
          <br />
          <b>
            <i>{t('optionsList.extraColorNotice')}</i>
          </b>
          <br />
          <i>{t('optionsList.extraColorNoticeText')}</i> */}
        </Typography>
      </div>
    );
  };

  if (!isWidthUp("sm", width)) {
    return (
      <MobileMenuStep
        doDisplay={
          doDisplayMobile &&
          currentModalContentOption === modalContentOptions.RENDER_ITEMMENU
        }
        renderStep={() => (
          <div className={classes.detailList}>{renderOptions()}</div>
        )}
        heading={optionclassification.title}
        backFunc={() => {
          if (currentModalContentOption) {
            setModalContentOption(modalContentOptions.RENDER_OVERVIEW);
          }
        }}
        closeFunc={null}
      />
    );
  }
  return (
    <Menu
      className={clsx(classes.optionsMenu)}
      onCancel={closeMenu}
      onClose={closeMenu}
      open={show && !!optionclassification.identifier}
      keepMounted
      anchorEl={optionRef}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        style: {
          // height 32px -  half of minheight
          marginTop: `${32 / 2}px`,
        },
      }}
    >
      <Button
        className={classes.closeButton}
        onClick={closeMenu}
        color="inherit"
      >
        <CloseMenuIcon />
      </Button>

      <div className={classes.contentStyle}>{renderOptions()}</div>
    </Menu>
  );
  /*
  return (
    <>
      {show && !!optionclassification.identifier
                && (
                  <Popper
                    className={clsx(classes.optionsMenu)}
                    placement="bottom-left"
                    modifiers={{
                      offset: {
                        offset: '0, 10',
                      },
                    }}
                    open={Boolean(optionRef)}
                    anchorEl={optionRef}
                    transition
                    disablePortal
                  >
                    {({ TransitionProps }) => (
                      <Grow
                        {...TransitionProps}
                      >
                        <Paper
                          style={{ // height 32px -  half of minheight
                            marginTop: `${32 / 2}px`,
                          }}
                        >
                          <ClickAwayListener onClickAway={closeMenu}>
                            <div >
                              <Button className={classes.closeButton} onClick={closeMenu} color="inherit">
                                <CloseMenuIcon />
                              </Button>

                              <div className={classes.contentStyle}>{renderOptions()}</div>

                            </div>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                )}
    </>
  );
  */
};

OptionsList.defaultProps = {
  addCheckedOptionclassification: () => {},
  isLoading: false,
  onClose: () => {},
  onSelect: () => {},
  onToggle: () => {},
  options: [],
  optionclassification: {},
  show: false,
  viewDetails: () => {},
  viewStockInformation: () => {},
  LoadingComponent: LoadingOverlay,
  OptionComponent: Option,
};

OptionsList.propTypes = {
  addCheckedOptionclassification: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isLoading: PropTypes.bool,
  onClose: PropTypes.func,
  onSelect: PropTypes.func,
  onToggle: PropTypes.func,
  options: PropTypes.array,
  optionclassification: PropTypes.object,
  show: PropTypes.bool,
  viewDetails: PropTypes.func,
  viewStockInformation: PropTypes.func,
  LoadingComponent: PropTypes.elementType,
  OptionComponent: PropTypes.elementType,
};

export default withWidth({ initialWidth: "lg" })(
  withStyles(styles, { name: "OptionsList" })(OptionsList)
);
